export const setShops = 'setShops';
export const setSaleType = 'setSaleType';
export const setCurrentVAS = 'setCurrentVAS';
export const setCustomerDetails = 'setCustomerDetails';
export const setShippingAddress = 'setShippingAddress';
export const setShippingTimeSlot = 'setShippingTimeSlot';
export const setShopMenu = 'setShopMenu';
export const setMerchantDetails = 'setMerchantDetails';
export const setMerchantShopDetails = 'setMerchantShopDetails';